export { domainToConfigSetName } from "@wraps/core/config-set-name";
